import * as types from '../constants/actionTypes';
import { wrapCall } from '../utils/serviceUtils';
import { api } from '../utils/services';
import constants from '../constants';
import AppUtils from "../utils/AppUtils";
import ApiHelper from "../utils/ApiHelper";
import {logDebug} from "src/js/utils/AppLog";
import {FETCH_REGIONS} from "../constants/actionTypes";

export const resetRegionsData = () => {
  return {
    type: types.RESET_REGIONS_DATA
  };
};
export const resetActivityRegionsData = () => {
  return {
    type: types.RESET_ACTIVITY_REGIONS_DATA
  };
};
export const resetSRegionsData = () => {
  return {
    type: types.RESET_S_REGIONS_DATA
  };
};
export const resetSActivityRegionsData = () => {
  return {
    type: types.RESET_S_ACTIVITY_REGIONS_DATA
  };
};

export const resetLocalitiesData = () => {
  return {
    type: types.RESET_LOCALITIES_DATA
  };
};
export const resetEmployeeLocalitiesData = () => {
  return {
    type: types.RESET_EMPLOYEE_LOCALITIES_DATA
  };
};
export const resetActivityLocalitiesData = () => {
  return {
    type: types.RESET_ACTIVITY_LOCALITIES_DATA
  };
};
export const resetSLocalitiesData = () => {
  return {
    type: types.RESET_S_LOCALITIES_DATA
  };
};
export const resetSActivityLocalitiesData = () => {
  return {
    type: types.RESET_S_ACTIVITY_LOCALITIES_DATA
  };
};
export const resetSEmployeeLocalitiesData = () => {
  return {
    type: types.RESET_S_EMPLOYEE_LOCALITIES_DATA
  };
};

export const resetSubLocalitiesData = () => {
  return {
    type: types.RESET_SUB_LOCALITIES_DATA
  };
};
export const resetActivitySubLocalitiesData = () => {
  return {
    type: types.RESET_ACTIVITY_SUB_LOCALITIES_DATA
  };
};
export const resetSSubLocalitiesData = () => {
  return {
    type: types.RESET_S_SUB_LOCALITIES_DATA
  };
};
export const resetSActivitySubLocalitiesData = () => {
  return {
    type: types.RESET_S_ACTIVITY_SUB_LOCALITIES_DATA
  };
};

export const fetchRegions = (search, countryIds) => {
  return wrapCall(
    api.get(`/userB/regions?page=1&perPage=1000&search=${search || ''}${countryIds ? '&countryIds='+ countryIds.join(',') : ''}`),
    types.FETCH_REGIONS,
    {search}
  );
};
export const fetchActivityRegions = (search) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${constants.localities.regionType}&search=${search}`),
    types.FETCH_ACTIVITY_REGIONS,
    { search }
  );
};
export const fetchSRegions = (search) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${constants.localities.regionType}&search=${search}`),
    types.FETCH_S_REGIONS,
    { search }
  );
};
export const fetchSActivityRegions = (search) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${constants.localities.regionType}&search=${search}`),
    types.FETCH_S_ACTIVITY_REGIONS,
    { search }
  );
};

export const fetchLocalities = (search, countryIds) => {
  return wrapCall(
    api.get(`/userB/localities?page=1&perPage=100&type=${constants.localities.localityType}&search=${search}${countryIds ? '&countryIds='+ countryIds.join(',') : ''}`),
    types.FETCH_LOCALITIES,
    {search}
  );
};
export const fetchEmployeeLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=1000&type=${id ? constants.localities.subLocalityType : constants.localities.localityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_EMPLOYEE_LOCALITIES,
    { search, id }
  );
};
export const fetchActivityLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${id ? constants.localities.subLocalityType : constants.localities.localityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_ACTIVITY_LOCALITIES,
    { search, id }
  );
};
export const fetchSLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${id ? constants.localities.subLocalityType : constants.localities.localityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_S_LOCALITIES,
    { search, id }
  );
};
export const fetchSEmployeeLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${id ? constants.localities.subLocalityType : constants.localities.localityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_S_EMPLOYEE_LOCALITIES,
    { search, id }
  );
};
export const fetchSActivityLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${id ? constants.localities.subLocalityType : constants.localities.localityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_S_ACTIVITY_LOCALITIES,
    { search, id }
  );
};

export const fetchSubLocalities = (search, countryIds) => {
  return wrapCall(
    api.get(`/userB/localities?page=1&perPage=100&type=${constants.localities.subLocalityType}&search=${search}${countryIds ? '&countryIds='+ countryIds.join(',') : ''}`),
    types.FETCH_SUB_LOCALITIES,
    {search}
  );
};

export const fetchActivitySubLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${constants.localities.subLocalityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_ACTIVITY_SUB_LOCALITIES,
    {search, id}
  );
};
export const fetchSSubLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${constants.localities.subLocalityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_S_SUB_LOCALITIES,
    { search, id }
  );
};
export const fetchSActivitySubLocalities = (search, id) => {
  return wrapCall(
    api.get(`/localities?page=1&perPage=100&type=${constants.localities.subLocalityType}&search=${search}${id ? '&localityId=' + id : ''}`),
    types.FETCH_S_ACTIVITY_SUB_LOCALITIES,
    { search, id }
  );
};

export const fetchNationalities = (excludeDefault, search) => {
  let url = `/pNationalities?page=1&perPage=1000`;
  if (excludeDefault) {
    url += `&excludeDefault=1`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  return wrapCall(
    api.get(url),
    types.FETCH_ACTIVITY_NATIONALITIES,
    {search}
  );
};

export const fetchCountries = (search) => {
  let url = `/countries?page=1&perPage=1000`;
  if (search) {
    url += `&search=${search}`;
  }
  return wrapCall(
    api.get(url),
    types.FETCH_COUNTRIES,
    {search}
  );
};

export const showGeoLocationLoading = () => {
  return {
    type: types.SHOW_GEO_LOCATION_LOADING
  };
};
export const hideGeoLocationLoading = () => {
  return {
    type: types.HIDE_GEO_LOCATION_LOADING
  };
};
